import CustomTooltip from '../utils/tooltip';

let toastTimeout = null;
let tooltipInstance = null;

function showToast(message, type = 'success', duration = 3000) {
  const toast = document.querySelector('#toast');
  const icon = document.querySelector('#toast-icon');
  const messageEl = document.querySelector('#toast-message');
  if (!toast || !icon || !messageEl) return;
  toast.className = 'toast';
  const iconMap = { success: 'check_circle', error: 'error', warning: 'warning', info: 'info' };
  icon.textContent = iconMap[type] || 'info';
  messageEl.textContent = message;
  toast.classList.add(`${type}-util`, 'show');
  clearTimeout(toastTimeout);
  toastTimeout = setTimeout(() => { toast.classList.remove('show'); }, duration);
}

function showDialog(id) {
  const dialog = document.querySelector(`#${id}`);
  if (!dialog) return;
  document.querySelectorAll('.dialog.show').forEach(d => {
    if (d.id !== id) d.classList.remove('show');
  });
  dialog.classList.add('show');
  document.body.classList.add('disabled-scroll');
  if (!history.state || history.state.dialog !== id) {
    history.pushState({ dialog: id }, '');
  }
}

function hideDialog(id, fromPopstate = false) {
  const dialog = document.querySelector(`#${id}`);
  if (dialog && dialog.classList.contains('show')) {
    dialog.classList.remove('show');
    if (document.querySelectorAll('.dialog.show').length === 0) {
      document.body.classList.remove('disabled-scroll');
    }
  }
  if (!fromPopstate && history.state && history.state.dialog === id) {
    history.replaceState(null, '', window.location.href);
  }
}

function showLightbox(src) {
  const img = document.querySelector('#lightbox-img');
  const box = document.querySelector('#lightbox');
  if (!img || !box) return;
  img.src = src;
  img.alt = 'Preview gambar';
  box.classList.add('active');
  document.body.classList.add('disabled-scroll');
}

function switchDialog(fromId, toId, callback) {
  hideDialog(fromId);
  setTimeout(async () => {
    showDialog(toId);
    if (callback) {
      try {
        await callback();
      } catch (e) {
        // ignore errors in callback
      }
    }
  }, 100);
}

function hideLightbox() {
  const box = document.querySelector('#lightbox');
  if (box) box.classList.remove('active');
  document.body.classList.remove('disabled-scroll');
}

function copyShareLink() {
  const urlInput = document.querySelector('#share-url');
  if (!urlInput) return;
  navigator.clipboard.writeText(urlInput.value).then(() => {
    showToast('Link berhasil disalin', 'success');
  }).catch(() => {
    urlInput.select();
    document.execCommand('copy');
    showToast('Link berhasil disalin', 'success');
  });
}

function shareToSocial(platform) {
  const urlInput = document.querySelector('#share-url');
  if (!urlInput) return;
  const url = urlInput.value;
  const text = 'Lihat cerita menarik ini di HeliaEDU';
  let shareUrl = '';
  switch (platform) {
    case 'whatsapp':
      shareUrl = `https://wa.me/?text=${encodeURIComponent(text + ' ' + url)}`;
      break;
    case 'facebook':
      shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;
      break;
    case 'twitter':
      shareUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(url)}`;
      break;
    default:
      break;
  }
  if (shareUrl) {
    window.open(shareUrl, '_blank', 'width=600,height=400');
    hideDialog('share-dialog');
  }
}

function setShareUrl(url) {
  const shareUrlInput = document.querySelector('#share-url');
  if (shareUrlInput) {
    shareUrlInput.value = url;
  }
}

function showConfirmDialog(message, onConfirm) {
  const msgEl = document.querySelector('#confirm-message');
  if (msgEl) msgEl.textContent = message;
  showDialog('confirm-dialog');
  const accept = document.querySelector('#confirm-accept');
  const cancel = document.querySelector('#confirm-cancel');
  const acceptHandler = () => { hideDialog('confirm-dialog'); if (onConfirm) onConfirm(); cleanup(); };
  const cancelHandler = () => { hideDialog('confirm-dialog'); cleanup(); };
  const cleanup = () => {
    accept.removeEventListener('click', acceptHandler);
    cancel.removeEventListener('click', cancelHandler);
  };
  if (accept && cancel) {
    accept.addEventListener('click', acceptHandler);
    cancel.addEventListener('click', cancelHandler);
  }
}

function initTooltips() {
  if (!tooltipInstance) {
    tooltipInstance = new CustomTooltip();
  } else {
    tooltipInstance.reinit();
  }
}

function reinitTooltips() {
  if (tooltipInstance) {
    tooltipInstance.reinit();
  }
}

export { showToast, showDialog, hideDialog, showLightbox, hideLightbox, showConfirmDialog, setShareUrl, copyShareLink, shareToSocial, initTooltips, reinitTooltips, switchDialog, togglePopup, hidePopup, hideAllPopups };

function togglePopup(id) {
  const popup = document.getElementById(id);
  if (!popup) return;
  const isVisible = popup.classList.contains('show');
  hideAllPopups();
  if (!isVisible) {
    popup.classList.add('show');
    const tickMap = {
      'dialog-bookmark': 'bookmark-tick',
      'dialog-notification': 'notification-tick',
      'app-setting': 'settings-btn',
      'distance-dialog': 'distance-filter'
    };
    const tickId = tickMap[id];
    if (tickId) {
      const tick = document.getElementById(tickId);
      if (tick) tick.classList.add('active');
    }
  }
}

function hidePopup(id) {
  const popup = document.getElementById(id);
  if (popup) popup.classList.remove('show');
  const tickMap = {
    'dialog-bookmark': 'bookmark-tick',
    'dialog-notification': 'notification-tick',
    'app-setting': 'settings-btn',
    'distance-dialog': 'distance-filter'
  };
  const tickId = tickMap[id];
  if (tickId) {
    const tick = document.getElementById(tickId);
    if (tick) tick.classList.remove('active');
  }
}

function hideAllPopups() {
  ['dialog-bookmark','dialog-notification','distance-dialog','app-setting'].forEach(id => hidePopup(id));
}

